// @flow
import React, { ComponentType } from 'react';
import { connect } from 'react-redux';
import ErrorBoundary from 'components/ErrorBoundary';

import AccountDiscoveryDialog from 'components/Dialogs/AccountDiscovery';
import { DIALOG_TYPE as DIALOG_TYPE_ACCOUNT_DISCOVERY } from 'components/Dialogs/AccountDiscovery/types';

import { DIALOG_TYPE as DIALOG_TYPE_ALERT } from 'components/Dialogs/AlertDialog/types';
import AlertDialog from 'components/Dialogs/AlertDialog';

import ConfirmationDialog, { DIALOG_TYPE as DIALOG_TYPE_CONFIRMATION } from 'components/Dialogs/ConfirmationDialog';

import { DIALOG_TYPE as DIALOG_TYPE_FORM } from 'components/Dialogs/FormDialog/types';
import FormDialog from 'components/Dialogs/FormDialog';

import { DIALOG_TYPE as DIALOG_TYPE_NOTIFICATION } from 'components/Dialogs/NotificationDialog/types';
import NotificationDialog from 'components/Dialogs/NotificationDialog';

import RefreshTimeoutDialog, { DIALOG_TYPE as DIALOG_TYPE_REFRESH_TIMEOUT }
  from 'components/Dialogs/RefreshTimeoutDialog';

import { DIALOG_TYPE as DIALOG_TYPE_NPS_SURVEY } from 'components/Dialogs/NPSSurveyDialog/types';
import NPSSurveyDialog from 'components/Dialogs/NPSSurveyDialog';

import WFBillsScoutDialog from 'components/Dialogs/WfBillScout';
import { DIALOG_TYPE as DIALOG_TYPE_WF_BILLS_SCOUT } from 'components/Dialogs/WfBillScout/types';

import WFDesktop from 'components/Dialogs/WFDesktopFeatures';
import { DIALOG_TYPE as DIALOG_TYPE_WF_DESKTOP_FEATURES } from 'components/Dialogs/WFDesktopFeatures/types';

import HelpSupportDialog from 'components/Dialogs/HelpSupportDialog';
import { DIALOG_TYPE as DIALOG_HELP_SUPPORT } from 'components/Dialogs/HelpSupportDialog/types';

import { DIALOG_TYPE as DIALOG_TYPE_MCP } from 'components/Dialogs/MCPDialog/mcpDialogActions';
import MCPDialog from 'components/Dialogs/MCPDialog/mcpDialogIndex';

import { DIALOG_TYPE as DIALOG_TYPE_WF_BUDGET_SETUP } from 'components/Dialogs/WFBudgetSetup/actions';
import WFBudgetSetup from 'components/Dialogs/WFBudgetSetup/index';

import { getActiveModals } from 'data/rootUi/selectors';

import { DIALOG_TYPE as DIALOG_TYPE_DELETE_REMINDER } from 'components/Dialogs/DeleteReminderDialog/actions';
import DeleteReminderDialog from 'components/Dialogs/DeleteReminderDialog';

import { DIALOG_TYPE as DIALOG_TYPE_MATCH_TXN } from 'components/Dialogs/MatchTxnDialog/actions';
import MatchTxnDialog from 'components/Dialogs/MatchTxnDialog';

import { DIALOG_TYPE as DIALOG_TYPE_VIEW_SERIES } from 'components/Dialogs/ViewSeriesDialog/actions';
import ViewSeriesDialog from 'components/Dialogs/ViewSeriesDialog';

export const MODAL_COMPONENTS = {};

export const RegisterModalComponent = (key: string, component: ComponentType<any>) => {
  MODAL_COMPONENTS[key] = component;
};

RegisterModalComponent(DIALOG_TYPE_ACCOUNT_DISCOVERY, AccountDiscoveryDialog);
RegisterModalComponent(DIALOG_TYPE_ALERT, AlertDialog);
RegisterModalComponent(DIALOG_TYPE_CONFIRMATION, ConfirmationDialog);
RegisterModalComponent(DIALOG_TYPE_FORM, FormDialog);
RegisterModalComponent(DIALOG_TYPE_NOTIFICATION, NotificationDialog);
RegisterModalComponent(DIALOG_TYPE_REFRESH_TIMEOUT, RefreshTimeoutDialog);
RegisterModalComponent(DIALOG_TYPE_NPS_SURVEY, NPSSurveyDialog);
RegisterModalComponent(DIALOG_TYPE_WF_BILLS_SCOUT, WFBillsScoutDialog);
RegisterModalComponent(DIALOG_TYPE_WF_DESKTOP_FEATURES, WFDesktop);
RegisterModalComponent(DIALOG_HELP_SUPPORT, HelpSupportDialog);
RegisterModalComponent(DIALOG_TYPE_MCP, MCPDialog);
RegisterModalComponent(DIALOG_TYPE_WF_BUDGET_SETUP, WFBudgetSetup);
RegisterModalComponent(DIALOG_TYPE_DELETE_REMINDER, DeleteReminderDialog);
RegisterModalComponent(DIALOG_TYPE_MATCH_TXN, MatchTxnDialog);
RegisterModalComponent(DIALOG_TYPE_VIEW_SERIES, ViewSeriesDialog);


type Props = {
  modals: Array<any>,
}

const RootModal = ({ modals }: Props) => {
  if (modals.size === 0) {
    return null;
  }

  return (
    modals.map((modal: any) => {
      const modalProps = {};
      modal.props.forEach((value, key) => { modalProps[key] = value; });

      const ModalComponent = MODAL_COMPONENTS[modal.type];
      return (
        <ErrorBoundary key={modal.id}>
          <ModalComponent key={modal.id} dialogId={modal.id} {...modalProps} />;
        </ErrorBoundary>
      );
    })
  );
};

function mapStateToProps(state) {
  return {
    modals: getActiveModals(state),
  };
}

export default connect(mapStateToProps)(RootModal);
